import UserLayout from './UserLayout.jsx';

export {UserLayout}



// WEBPACK FOOTER //
// ./components/layouts/user/index.js